import { render, staticRenderFns } from "./VueBulmaNotification.vue?vue&type=template&id=d9e428dc&"
import script from "./VueBulmaNotification.vue?vue&type=script&lang=js&"
export * from "./VueBulmaNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports